require('./plugins/slick');
require('./modules/share');

var Theme = require('./modules/theme');

jQuery(document).ready(function($) {
	Theme.init();

	// Attach the share module to a click event
	$('a[data-share]').share({
		count: false
	});
});
